import { render, staticRenderFns } from "./OrdersLogsModal.vue?vue&type=template&id=794b1f0a&scoped=true"
import script from "./OrdersLogsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersLogsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdersLogsModal.vue?vue&type=style&index=0&id=794b1f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b1f0a",
  null
  
)

export default component.exports